import { uniq } from 'lodash/fp';

import { ProductList, ProductListSection } from '../../../types/__codegen__/sanity/graphql';
import getSaleableCombinedProductIds from '../../../utils/get-saleable-combined-product-ids';
import getSaleableProductIds from '../../../utils/get-saleable-product-ids';

const productIdFields = ['productIdsCouple', 'productIdsFamily', 'productIdsSingle', 'productIdsSingleParent'] as const;

const getProductListIds = (productList: ProductList) =>
  productIdFields
    .flatMap((field) => productList[field] ?? [])
    .filter((productId): productId is string => Boolean(productId));

const getSaleableProductIdsFromProductListSections = (productListSections: ProductListSection[]) => {
  const saleableProductIds = new Set([...getSaleableProductIds(), ...getSaleableCombinedProductIds()]);
  const productIds = productListSections.flatMap((section) =>
    (section.productLists ?? []).flatMap((productList) => (productList ? getProductListIds(productList) : [])),
  );

  return uniq(productIds).filter((productId) => saleableProductIds.has(productId));
};

export default getSaleableProductIdsFromProductListSections;
